import { classNames } from "../../helpers/classNames";

const Textarea = ({
  label,
  labelClasses,
  inputClasses,
  inputPlaceholder,
  inputValue,
  inputName,
  errorType,
  required,
  onChange = () => {},
  ...props
}) => {
  return (
    <>
      <div className="relative space-y-1 w-full">
        {label && (
          <div className={classNames("text-xs font-medium text-text-disabled font-CanelaDeck mb-1", labelClasses)}>
            {label}
            {required && (
              <span className="text-[8px] text-red-500 ml-1 absolute top-[-2px]">
                <i className="fa-solid fa-asterisk"></i>
              </span>
            )}
          </div>
        )}
        <div className="relative flex">
          <textarea
            className={classNames(
              "w-full h-20  rounded-md bg-white border border-text-secondary/50 py-3 px-3 text-sm font-CanelaDeck text-sidebar !ring-0 !outline-0 focus:border-text-disabled transition-all duration-200 resize-none overflow-auto scroll-smooth scrollbar placeholder:text-text-disabled",
              inputClasses
            )}
            placeholder={inputPlaceholder}
            name={inputName}
            value={inputValue}
            onChange={onChange}></textarea>
        </div>
        {errorType && errorType === "error" && (
          <div className="text-xs text-red-600 mt-1">
            <i className="fa-regular fa-fw fa-square-exclamation text-sm mr-1"></i>
            This field is required
          </div>
        )}
        {errorType && errorType === "warning" && (
          <div className="text-xs text-amber-600 mt-1">
            <i className="fa-regular fa-fw fa-triangle-exclamation text-sm mr-1"></i>
            This field has a warning
          </div>
        )}
        {errorType && errorType === "success" && (
          <div className="text-xs text-green-600 mt-1">
            <i className="fa-regular fa-fw fa-circle-check text-sm mr-1"></i>
            Verified
          </div>
        )}
      </div>
    </>
  );
};

export default Textarea;
